import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { ScrollProgress } from './components/motion';
import Nav from './sections/Nav';
import Hero from './sections/Hero';
import About from './sections/About';
import MarketHours from './sections/MarketHours';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

export default function LandingPage() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ScrollProgress />
      <Nav />
      <main>
        <Hero />
        <About />
        <MarketHours />
        <Contact />
      </main>
      <Footer />
    </ThemeProvider>
  );
}
